import { 
  doc, 
  getDoc
} from 'firebase/firestore';
import { db } from '@/lib/firebase';

/**
 * Get current commission rate from Firebase
 */
export const getCurrentCommissionRate = async (): Promise<number> => {
  try {
    console.log('Getting current commission rate from Firebase...');
    
    const settingsRef = doc(db, 'config', 'commissionSettings');
    const settingsDoc = await getDoc(settingsRef);
    
    if (!settingsDoc.exists()) {
      console.log('Commission settings not found, using default rate of 10%');
      return 10; // Default rate
    }
    
    const data = settingsDoc.data();
    const rate = data.commissionRate || 10;
    
    console.log('Commission rate loaded:', rate + '%');
    return rate;
  } catch (error) {
    console.error('Error getting commission rate:', error);
    return 10; // Default fallback
  }
}; 